<template>
    <div>
        <template v-if="!checked">
            <sau-loading>
                <template slot="message">Fetching Remote DNS Details</template>
            </sau-loading>
        </template>
        <div class="row" v-else-if="Object.keys(this.ips).length > 0">
            <div class="col">
                <div class="sau-bx bx-pad">
                    <table class="sau-bx-table sau-font sm">
                        <tbody>
                            <tr v-for="(details, ip) in ips" :key="ip">
                                <td width="40" class="py-2"><i class="far fa-file-alt p-2" style="font-size:29px;"></i></td>
                                <td>{{ ip }}</td>
                                <td>{{ details ? details.data : 'Not Set' }}</td>
                                <td align="right"><a href="" class="sau-link-button sm" v-b-modal.edit-ip @click.prevent="setActiveIp(ip)">Edit</a></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <div v-else>

            <sau-apiro-response type="error" support="true">
                <template slot="message">Your Reverse DNS is unavailable right now.</template>
                <template slot="details">
                    <p>This is a temporary issue, so please try again later or contact our Support Team.</p>
                </template>
            </sau-apiro-response>

        </div>

        <b-modal id="edit-ip"
                centered
                title="Update PTR Record"
                @ok="editPtrRecord"
                @cancel="resetActiveIp"
                :ok-disabled="activeIp.data.length == 0"
                hide-footer
                cancel-variant="link"
                ref="modalEditIp"
                :no-close-on-backdrop="true">
                <div class="row">
                    <div class="col">
                        <input v-model="activeIp.data"
                                type="text"
                                v-on:input="$v.activeIp.data.$touch"
                                :class="{'is-valid' : $v.activeIp.data.$dirty && !$v.activeIp.data.$invalid, 'is-invalid' : $v.activeIp.data.$dirty && $v.activeIp.data.$invalid }"
                                class="form-control" />
                    </div>
                </div>
                <div class="row pt-6">
                    <div class="col">
                        <div class="float-right">
                            <a href="#" @click.prevent="cleanUpForm()">Cancel</a>
                            <a href="#" @click.prevent="resetPtrRecord()" class="btn btn-danger btn-sm ml-4">Reset PTR</a>
                            <button href="#" @click.prevent="editPtrRecord()" :disabled="$v.activeIp.data.$invalid" class="btn btn-sm ml-4" :class="{'btn-success' : !$v.activeIp.data.$invalid, 'btn-light' : $v.activeIp.data.$invalid}">Update PTR</button>
                        </div>
                    </div>
                </div>
        </b-modal>

    </div>
</template>
<script>
import { required, minLength } from 'vuelidate/lib/validators';

const hostnameValidator = (value) => {
    const re = /^([a-zA-Z0-9]|[a-zA-Z0-9][a-zA-Z0-9-]{0,61}[a-zA-Z0-9])(\.([a-zA-Z0-9]|[a-zA-Z0-9][a-zA-Z0-9-]{0,61}[a-zA-Z0-9]))*[\.]?$/;
    return re.test(value);
}

export default {
    props: ['service'],
    data() {
        return {
            response: {},
            errors: {},
            ips: {},
            checked: false,
            activeIp: {
                data: '',
                ip: ''
            },
        }
    },
    validations: {
        activeIp: {
            data: {
                required,
                minLength: minLength(3),
                hostnameValidator,
            }
         }
    },
    created() {
        this.startApp();
    },
    methods: {
        startApp() {
            this.checked = false;
            // Remove any carriage returns (arrow) before converting to an array
            let assigned = this.service.assignedips.replace(/(\r\n|\n|\r)/gm," ");
            let array = assigned.split(" ");
            array.push(this.service.ipaddress);
            let data = {
                // remove empty array elements
                ips: array.filter(Boolean)
            }
            // Post IP addresses to see which are editable
            this.getReverseDNS(data).then(response => {
                if(response.data.status == 'success') {
                    if(response.data.ips) {
                        this.ips = response.data.ips;
                    }
                }
                this.checked = true;
            }).catch(error => {
                this.error = error;
                this.checked = true;
            })
        },
        resetActiveIp() {
            this.activeIp = {
                data: '',
                ip: ''
            };
        },
        cleanUpForm() {
            //Hide modal
            this.modalHide('modalEditIp');
            //Reset validations
            this.$v.$reset();
        },
        setActiveIp(ip) {
            let selected = this.ips[ip]
            this.activeIp.data = selected ? selected.data : '';
            this.activeIp.ip = ip;
        },
        editPtrRecord() {
            this.$swal({
                title: "Updating PTR Record",
                text: "Please wait...",
                imageUrl: "/img/spinner-circle-120.gif",
                showConfirmButton: false,
                allowOutsideClick: false
            });
            let data = {
                ptr: this.activeIp.data,
                ip: this.activeIp.ip
            }
            this.updateReverseDNS(data).then(response => {
                this.startApp();
                this.$swal.close();
                this.$swal({
                    type:'success',
                    title: 'PTR Record Successfully Updated',
                    showConfirmButton: false,
                    timer: 3000
                });

                this.modalHide('modalEditIp');

            }).catch(error => {
                this.$swal.close();
                this.$swal({
                    type:'error',
                    title: 'There was an error updating your PTR record',
                    showConfirmButton: false,
                    timer: 5000
                });
                this.modalHide('modalEditIp');
            });
        },
        resetPtrRecord() {
            this.$swal({
                title: "Resetting PTR Record",
                text: "Please wait...",
                imageUrl: "/img/spinner-circle-120.gif",
                showConfirmButton: false,
                allowOutsideClick: false
            });
            let data = {
                ip: this.activeIp.ip
            };
            this.resetReverseDNS(data).then(response => {
                if(response.data.status == 'success') {
                    this.$swal.close();
                    this.$swal({
                        type:'success',
                        title: 'PTR Record Successfully Reset',
                        showConfirmButton: false,
                        timer: 3000
                    });
                    /** Update local ptr record on successful response */
                    this.ips[this.activeIp.ip] = {
                        data: response.data.ptr.data,
                    };
                    this.modalHide('modalEditIp');
                    this.resetActiveIp();
                } else {
                    this.$swal.close();
                    this.$swal({
                        type:'error',
                        title: 'There was an error resetting your PTR record',
                        showConfirmButton: false,
                        timer: 5000
                    });
                    this.modalHide('modalEditIp');
                }
            }).catch(error => {
                this.$swal.close();
                this.$swal({
                    type:'error',
                    title: 'There was an error resetting your PTR record',
                    showConfirmButton: false,
                    timer: 5000
                });
                this.modalHide('modalEditIp');
            })
        }
    }
}
</script>
